import { render, staticRenderFns } from "./chart-bar.vue?vue&type=template&id=35c86a46&"
import script from "./chart-bar.vue?vue&type=script&lang=ts&"
export * from "./chart-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports